/**
 * Synthetic assistant question wording for the three Fineco rebalancing starters.
 *
 * These strings are duplicated from the rebalancing-operations hint and must stay in sync.
 * Source of truth (verbatim wording):
 *   street-beat-fastapi/streetbeat_fastapi/skills/fineco/config/hints/fineco-rebalancing-operations-flow.md
 *
 * Changing wording here? Update the hint in the same change. Changing the hint? Update here.
 *
 * The plain rebalance asks the broad Step 3a question regardless of whether
 * `assets_to_buy_max`/`assets_to_sell_max` are already set — see the spec at
 * street-beat-fastapi/docs/superpowers/specs/2026-05-05-fineco-rebalancing-prefill-design.md
 * (non-goal: mirroring the hint's full conditional logic on the frontend).
 */

export type FinecoRebalancingStarterId = 'ribilanciare' | 'deposit' | 'withdraw';

export const FINECO_REBALANCING_SYNTHETIC_QUESTIONS: Record<FinecoRebalancingStarterId, string> = {
  ribilanciare: 'Vuoi impostare un numero massimo di operazioni di acquisto e/o vendita?',
  deposit: 'Di quanti euro vuoi incrementare il portafoglio?',
  withdraw: 'Di quanti euro vuoi decrementare il portafoglio?',
};
